import { Address } from "viem";
import { TokenBalanceQueryOptions } from "./useTokenBalance";
import { useAddressesByNetwork } from "./useAddressesByNetwork";
import { useTokenBalance } from "./useTokenBalance";

export const useWLooksBalance = (address: Address, queryOptions?: TokenBalanceQueryOptions) => {
  const addressesByNetwork = useAddressesByNetwork();
  return useTokenBalance({ contractAddress: addressesByNetwork.WLOOKS, address, queryOptions });
};
